import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for /settings/support/* — renders child routes via Outlet
export const Route = createFileRoute("/settings/support")({
  component: () => <Outlet />,
});
